import styled from 'styled-components'

export const Container = styled.div`
  width: 100vw;
  max-width: 1300px;
  margin: 1rem auto 0 auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  min-height: calc(100vh - 200px);

  @media only screen and (min-width: 520px) {
    padding: 1rem 1rem 1rem 6rem;
    align-items: flex-start;
  }

  div {
    display: flex;
    flex-direction: column;

    @media only screen and (min-width: 520px) {
      flex-direction: row;
    }
  }

  h2 {
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 1.8125rem;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
    /* margin: 0 auto; */

    @media only screen and (max-width: 900px) {
      //display: none;
    }
  }

  a {
    color: ${({ theme }) => `rgb(${theme.primary.base})`};
    font-weight: bold;
  }

  button {
    margin: 0 auto;
    padding: 1rem;
    color: ${({ theme }) => `rgb(${theme.primary.base})`};
    border: ${({ theme }) => `1px solid rgb(${theme.primary.base})`};
    border-radius: 4px;
    font-weight: 600;
    font-size: 1rem;
    line-height: 1.375rem;
    background: transparent;
    width: 95%;
  }

  .cards {
    gap: 1rem;
  }
`

export const SubscriptionContainer = styled.div`
  display: flex;
  flex-direction: column !important;
  padding: 1rem;
  background: ${({ theme }) => `rgb(${theme.component.background})`};
  border: ${({ theme }) => `1px solid rgb(${theme.grayscale[400]})`};
  max-width: 22rem !important;
  min-width: 22rem !important;
  min-height: 8rem;
  max-height: 15rem;
  margin: 0 auto;
  border-radius: 20px;
  cursor: pointer;

  @media only screen and (min-width: 900px) {
    &[data-quantity-cards='1'] {
      min-width: 15rem !important;
    }

    &[data-quantity-cards='2'] {
      min-width: 22rem !important;
    }
  }

  h3 {
    font-size: 1rem;
    height: 8.5rem;
    font-weight: 700;
    color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
    max-width: 27rem;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 7;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    line-height: 1.4rem;

    @media only screen and (max-width: 900px) {
    }
  }

  img {
    height: 4rem;
    max-width: 4rem;

    background-color: #fff;
    border-radius: 5px;
  }
`
